﻿import { ApiResourceFactory } from '../api.resource.factory'
import { GridModel, GridRequestModel, LocationModel, EntityModel, PlanDeliveryModel, SchemaModel, ImportProgressModel, ResponseListModel, ResponseDeleteModel, ImportStatusModel, LocationConfigurationProfileModel, ConfigurationProfileFunctionModel, ResponseValidateInfoModel, LocationFormValuesModel, ProblemClasssesModel } from '../api.models'
import { IImportService } from './api.app.service'
import { CommonHelper } from '../../../helpers/common-helper'

export interface ILocationsService extends IImportService {
    getLocations(req: GridRequestModel, state?: any): ng.IPromise<GridModel>
    saveLocation(req): ng.IPromise<LocationModel>
    getLocation(id, state?: any): ng.IPromise<LocationModel>
    deleteLocation(id): ng.IPromise<ResponseDeleteModel>
    getSchema(id, state?: any): ng.IPromise<SchemaModel>
    getSchemas(id, state?: any): ng.IPromise<ResponseListModel<SchemaModel>>
    getLocationConfigurationProfile(id, state?: any): ng.IPromise<LocationConfigurationProfileModel>
    saveLocationConfigurationProfile(model, state?: any): ng.IPromise<LocationConfigurationProfileModel>
    saveConfigurationProfile(model, state?: any): ng.IPromise<ConfigurationProfileFunctionModel>
    getProblems(model, state?: any): ng.IPromise<ProblemClasssesModel>
    saveProblems(model, state?: any): ng.IPromise<EntityModel>
    planDelivery(model, state?: any): ng.IPromise<EntityModel>
}

export class LocationsService implements ILocationsService {
    constructor(private apiResource: ApiResourceFactory) {

    }

    getLocations(req: GridRequestModel, state: any = {}) {
        var get = this.apiResource.locations.query
        state.request = get(req)
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getLocation(id, state: any = {}) {
        var get = this.apiResource.locations.get
        state.request = get({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state, false, rej.data.Message))
    }

    saveLocation(req): ng.IPromise<LocationModel> {
        return this.apiResource.locations.save(req).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch<any>(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    deleteLocation(id): ng.IPromise<ResponseDeleteModel> {
        return this.apiResource.locations.delete({ id: id }).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch<any>(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    getSchema(id, state: any = {}) {
        var get = this.apiResource.locations['getSchema']
        state.request = get({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getSchemas(id, state: any = {}) {
        var get = this.apiResource.locations['getSchemas']
        state.request = get({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return result
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getLocationConfigurationProfile(id, state: any = {}) {
        var get = this.apiResource.locations['getProfile']
        state.request = get({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    saveLocationConfigurationProfile(model, state: any = {}) {
        var get = this.apiResource.locations['saveProfile']
        state.request = get(model)
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    saveConfigurationProfile(model, state: any = {}) {
        var get = this.apiResource.locations['saveConfigurationProfile']
        state.request = get(model)
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    IsImportCompleted(model: GridModel) {
        return this.apiResource.locations['importIsCompleted'](model).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    getImportSummary(model: GridModel) {
        return this.apiResource.locations['importResume'](model).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    initImport(model: GridModel) {
        return this.apiResource.locations['importInit'](model).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    validateImport(guid: string) {
        return this.apiResource.locations['importValidate']({ guid: guid }).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    getImportData(guid: string) {
        return this.apiResource.locations['importGetData']({ guid: guid }).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    startImport(guid: string) {
        return this.apiResource.locations['importStart']({ guid: guid }).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    stopImport(guid: string) {
        return this.apiResource.locations['importStop']({ guid: guid }).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    importProgress(guid: string) {
        return this.apiResource.locations['importProgress']({ guid: guid }).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    importSummary(guid: string) {
        return this.apiResource.locations['importSummary']({ guid: guid }).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    getProblems(model: number[]) {
        return this.apiResource.locations['getProblems'](model).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    saveProblems(model: number[]) {
        return this.apiResource.locations['saveProblems'](model).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    planDelivery(model: PlanDeliveryModel) {
        return this.apiResource.locations['planDelivery'](model).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }
}
